module.exports = __webpack_public_path__ + "img/logo2.840da7d6.png";